import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { CreateScan, UpdateScan, Scans } from "./pages";

export const ScansRouter = [
  <Route
    path="/scans"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Scans />
      </ProtectedRoute>
    }
  />,

  <Route path="/scan">
    <Route
      path=":id"
      element={<ProtectedRoute roles={["Any"]}></ProtectedRoute>}
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateScan />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateScan />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const AdminScansRouter = [
  <Route
    path="/scans"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Scans />
      </ProtectedRoute>
    }
  />,

  <Route path="/scan">
    <Route
      path=":id"
      element={<ProtectedRoute roles={["Any"]}></ProtectedRoute>}
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateScan />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateScan />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientScansRouter = [
  <Route
    path="/scans"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Scans />
      </ProtectedRoute>
    }
  />,
];
